// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import consultationSummaryEntity from './entities/consultation-summary.json';
import consultationSummaryMenu from '../pages/consultation-summary/menu.json';
import consultationSummaryFullForm from '../pages/consultation-summary/forms/full.json';
import consultationSummaryContextForm from '../pages/consultation-summary/forms/context.json';
import consultationSummaryMiniForm from '../pages/consultation-summary/forms/mini.json';
import consultationSummaryLookupForm from '../pages/consultation-summary/forms/lookup.json';
import consultationSummaryTableView from '../pages/consultation-summary/views/table.json';
import consultationSummaryCardsView from '../pages/consultation-summary/views/cards.json';
import consultationSummaryDashboardView from '../pages/consultation-summary/views/dashboard.json';

/** Тип запису «Підсумок консультації» зі сторінками пакета: меню, форми та подання з pages/consultation-summary/. */
export const consultationSummaryDefinition: IRecordTypeDefinition = {
  ...consultationSummaryEntity,
  views: assembleViewSet({
      table: consultationSummaryTableView,
      cards: consultationSummaryCardsView,
      dashboard: consultationSummaryDashboardView,
  }),
  form: consultationSummaryFullForm,
  forms: { full: consultationSummaryFullForm, context: consultationSummaryContextForm, mini: consultationSummaryMiniForm, lookup: consultationSummaryLookupForm },
  menu: consultationSummaryMenu,
} as IRecordTypeDefinition;
